// extracted by mini-css-extract-plugin
export var BlogPost = "BlogPost-module--BlogPost--3dbS7";
export var BlogPost__header = "BlogPost-module--BlogPost__header--w9ZTC";
export var BlogPost__date = "BlogPost-module--BlogPost__date--3-eUu";
export var BlogPost__content = "BlogPost-module--BlogPost__content--1NNix";
export var BlogPost__nav = "BlogPost-module--BlogPost__nav--11IpQ";
export var BlogPost__prev = "BlogPost-module--BlogPost__prev--emRg2";
export var BlogPost__next = "BlogPost-module--BlogPost__next--2XX5O";